<section class="headline">
  <h3>Comments</h3>
  <p>Manage comments posted throughout this website.</p>
</section>

<ng-container *ngIf="comments$ | async as comments; else loadingOrError">
  <ng-container *ngIf="comments.length > 0; else noComments">
    <em>{{comments.length}} {{comments.length === 1 ? 'comment' : 'comments'}}</em>
    <div class="comment" *ngFor="let comment of comments">
      <div class="comment-info">
        <h2 class="title">{{comment.parent?.id}}</h2>
        <p>{{comment.content}}</p>
        <span>{{comment.author?.name}} • <em class="date">{{comment?.created?.seconds! * 1000 | dateAgo}}</em></span>
      </div>
      <div class="comment-actions">
        <button mat-icon-button [routerLink]="[nav_path.stories, comment.parent?.id]">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #noComments>
    <div class="">
      <h2 class="">No comments yet!</h2>
      <p class="">Read some stories and create the first comment to get us started.</p>
    </div>
  </ng-template>
</ng-container>

<ng-template #loadingOrError>
  <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
